namespace Gamification.Gamification {

    Serenity.Decorators.registerClass()
    export class Checklist2EditorDialog extends Serenity.Extensions.GridEditorDialog<ChecklistRow> {
        protected getFormKey() { return ChecklistForm.formKey; }
        protected getLocalTextPrefix() { return ChecklistRow.localTextPrefix; }
        protected getNameProperty() { return ChecklistRow.nameProperty; }

        protected form = new ChecklistForm(this.idPrefix);

        protected afterLoadEntity() {
            super.afterLoadEntity();
            if (this.isNew()) {
                if (this.idAssetEsperienza > 0) {
                    this.form.IdAssetEsperienza.value = this.idAssetEsperienza.toString();
                    Serenity.EditorUtils.setReadOnly(this.form.IdAssetEsperienza, true);
                }
            }
        }

        // /////////////////////////////////
        private _idAssetEsperienza: number;

        get idAssetEsperienza() {
            return this._idAssetEsperienza;
        }

        set idAssetEsperienza(value: number) {
            if (this._idAssetEsperienza != value) {
                this._idAssetEsperienza = value;
            }
        }
    }
}
